import { createSelector } from 'reselect';
import pathOr from 'ramda/src/pathOr';
import { CODES } from 'invision-core/src/components/metadata/codes/codes.constants';
import { createImmutableSelector } from 'invision-core/src/utilities/create.immutable.selector';
import { MetadataCodeTypeSelector } from 'invision-core/src/components/metadata/codes/codes.selectors';
import { createTableEtfPricingPlansHeaders, createTableEtfPricingPlansViewModel } from './contract.selectors.helper';
import { EARLY_TERMINATION_FEE_CHARGE_TYPES } from '../../components/shared/constants/etf.charge.type.contants';
import { SelectedContractDefinitionSelector } from './offering.order.selectors';
export var ContractSelector = function ContractSelector(state) {
  return pathOr(null, ['customercare', 'offeringOrder', 'data', 'selectedContract'], state);
};
export var ContractPricingPlanSelector = createSelector([ContractSelector], function (contract) {
  return pathOr(null, ['pricingPlan'], contract);
});
export var SelectedContractSelector = createSelector([ContractSelector], function (contract) {
  return pathOr(null, ['contractDetails'], contract);
});
export var IsFetchingSelectedContractSelector = createSelector([ContractSelector], function (contract) {
  return contract.isFetchingData;
});
export var SelectedContractPricingPlanEtfInstanceSelector = createSelector([SelectedContractDefinitionSelector], function (selectedContractDefinition) {
  return pathOr(null, ['PricingPlan', 'ConvergentBillerMetadata', 'EarlyTerminationFeeBillerRuleInstances', 0], selectedContractDefinition);
});
export var SelectedContractPricingPlanEtfScheduleSelector = createSelector([SelectedContractPricingPlanEtfInstanceSelector], function (pricingPlanEtfInstance) {
  var etfSchedules = pathOr(null, ['EarlyTerminationFeeSchedules'], pricingPlanEtfInstance);
  return pricingPlanEtfInstance && pricingPlanEtfInstance.ChargeTypeCode === EARLY_TERMINATION_FEE_CHARGE_TYPES.FLAT && etfSchedules && etfSchedules.length ? etfSchedules[0] : etfSchedules;
});
var EMPTY_TABLE_DATA = [];
export var ContractPricingPlanTableDataSelector = createSelector([MetadataCodeTypeSelector(CODES.EarlyTerminationFeeChargeType), SelectedContractPricingPlanEtfInstanceSelector], function (etfChargeTypes, pricingPlanEtfInstance) {
  var tableData = {
    columnDefs: createTableEtfPricingPlansHeaders(pricingPlanEtfInstance ? pricingPlanEtfInstance.ChargeTypeCode : null)
  };
  tableData.data = pricingPlanEtfInstance ? createTableEtfPricingPlansViewModel(pricingPlanEtfInstance, etfChargeTypes) : EMPTY_TABLE_DATA;
  return tableData;
});
export var ContractInstanceSelector = createImmutableSelector([ContractSelector], function (contract) {
  return contract && contract.orderContractInstance ? contract.orderContractInstance : null;
});